/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IntegrationCredentials } from './IntegrationCredentials';
import {
    IntegrationCredentialsFromJSON,
    IntegrationCredentialsFromJSONTyped,
    IntegrationCredentialsToJSON,
    IntegrationCredentialsToJSONTyped,
} from './IntegrationCredentials';

/**
 * 
 * @export
 * @interface CreateIntakeIntegration200Response
 */
export interface CreateIntakeIntegration200Response {
    /**
     * 
     */
    data?: IntegrationCredentials;
}

/**
 * Check if a given object implements the CreateIntakeIntegration200Response interface.
 */
export function instanceOfCreateIntakeIntegration200Response(value: object): value is CreateIntakeIntegration200Response {
    return true;
}

export function CreateIntakeIntegration200ResponseFromJSON(json: any): CreateIntakeIntegration200Response {
    return CreateIntakeIntegration200ResponseFromJSONTyped(json, false);
}

export function CreateIntakeIntegration200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateIntakeIntegration200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : IntegrationCredentialsFromJSON(json['data']),
    };
}

export function CreateIntakeIntegration200ResponseToJSON(json: any): CreateIntakeIntegration200Response {
    return CreateIntakeIntegration200ResponseToJSONTyped(json, false);
}

export function CreateIntakeIntegration200ResponseToJSONTyped(value?: CreateIntakeIntegration200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': IntegrationCredentialsToJSON(value['data']),
    };
}

